// extracted by mini-css-extract-plugin
module.exports = {"container":"SpecialOfferFootnote_container__Roblf","termAndConditionsLink":"SpecialOfferFootnote_termAndConditionsLink__iBFw9"};